export interface Language {
  code: string
  name: string
  flag: string
}

export const languages: Language[] = [
  { code: "pl", name: "Polski", flag: "🇵🇱" },
  { code: "en", name: "English", flag: "🇬🇧" },
  { code: "uk", name: "Українська", flag: "🇺🇦" },
  { code: "ru", name: "Русский", flag: "🇷🇺" },
  { code: "be", name: "Беларуская", flag: "🇧🇾" },
  { code: "ro", name: "Română", flag: "🇷🇴" },
  { code: "hy", name: "Հայերեն", flag: "🇦🇲" },
  { code: "az", name: "Azərbaycan", flag: "🇦🇿" },
  { code: "lt", name: "Lietuvių", flag: "🇱🇹" },
  { code: "lv", name: "Latviešu", flag: "🇱🇻" },
  { code: "et", name: "Eesti", flag: "🇪🇪" },
  { code: "kk", name: "Қазақ", flag: "🇰🇿" },
  { code: "uz", name: "O'zbek", flag: "🇺🇿" },
  { code: "ky", name: "Кыргыз", flag: "🇰🇬" },
  { code: "tk", name: "Türkmen", flag: "🇹🇲" },
  { code: "tg", name: "Тоҷикӣ", flag: "🇹🇯" },
  { code: "de", name: "Deutsch", flag: "🇩🇪" },
  { code: "fr", name: "Français", flag: "🇫🇷" },
  { code: "es", name: "Español", flag: "🇪🇸" },
  { code: "it", name: "Italiano", flag: "🇮🇹" },
]
